import React from 'react'

import Typography from './UniformComponents/Typography'

const CustomToast = ({ toastProps }) => (
    <div className="">
        <Typography type="b">{toastProps.title}</Typography>

        <Typography>{toastProps.body}</Typography>
    </div>
)

export default CustomToast
